export default __webpack_public_path__ + "static/media/looker_crude.514b2f96.JPG";